// extracted by mini-css-extract-plugin
module.exports = {"date-container":"ArticleDate_date-container__1_IcA","date":"ArticleDate_date__235F5","icon":"ArticleDate_icon__3xGJG"};